import { type Ref } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { RECAPTCHA_KEY } from '@/defs/misc'

type Props = {
  onCaptcha?: () => void
  ref?: Ref<ReCAPTCHA>
  size?: 'compact' | 'normal' | 'invisible'
}

export const Captcha = ({ onCaptcha, ref, size }: Props) => (
  <ReCAPTCHA onChange={onCaptcha} ref={ref} sitekey={RECAPTCHA_KEY} size={size} />
)
